import { storeToRefs } from 'pinia';
import { navigationStore } from '~/stores/navigation';

export default function () {

  const store = navigationStore();
  const { isNavigationOpen, currentFirstLevelCategorySlug } = storeToRefs(store);

  return {
    toggleNavigation: store.toggleNavigation,
    setCurrentFirstLevelCategorySlug: store.setCurrentFirstLevelCategorySlug,
    isNavigationOpen,
    currentFirstLevelCategorySlug,
  };

}